import { dreiklangMidi, tonleiterMidi } from '../domain/tonarten'
import { spieleTon, spieleSequenz, spieleAkkord, kadenz } from '../domain/audio'
import type { Tonart } from '../types'

interface Props {
  tonart: Tonart | null
}

export function KlangButtons({ tonart }: Props) {
  const disabled = !tonart
  return (
    <div className="klang-buttons">
      <button disabled={disabled} onClick={() => tonart && spieleTon(tonart.tonicMidi, { dauer: 1.2 })}>
        Grundton
      </button>
      <button disabled={disabled} onClick={() => tonart && spieleAkkord(dreiklangMidi(tonart), { dauer: 1.4 })}>
        Dreiklang
      </button>
      <button disabled={disabled} onClick={() => tonart && spieleSequenz(tonleiterMidi(tonart))}>
        Tonleiter
      </button>
      <button disabled={disabled} onClick={() => tonart && kadenz(tonart.tonicMidi)}>
        Kadenz I-IV-V-I
      </button>
    </div>
  )
}
